export default __webpack_public_path__ + "static/media/school_logo_background.c747d277.jpg";